/*
 * Description: Input Checkbox Field Web Component
 * Purpose: A reusable input field component specifically designed for checkbox input
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - Displays a label for the input field
 * - Designed to be embedded within other components
 * 
 * Usage:
 * <input-checkbox-field label="Field Label" value="Field value"></input-checkbox-field>
 * 
 * Attributes:
 * - label: String - The label/name to display for this input field
 * - value: String - The checkbox value
 * 
 */

class input_checkbox_field extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const value = this.getAttribute("value");
        const label = this.getAttribute("label");
        this.innerHTML = `<div >
            <input type="checkbox" id="check1" name="option1" value="${value}">
            <label for="check1">${label}</label>
        </div>`;
        this.dataset.rendered = "true";
    }
}

export { input_checkbox_field };
